import { Box, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import PrimaryButton from "components/Button";
import moment from "moment";

// Section-level failure state: shown in place of a widget/section that failed
// to load, instead of leaving an endless spinner or a silently blank area.
const ErrorRetry = ({
  message = "Webbieshop is temporarily taking longer than expected. We are reconnecting automatically.",
  onRetry,
  dense = false,
  lastUpdated,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.25,
        textAlign: "center",
        py: dense ? 2 : 5,
        px: 2,
      }}
    >
      <Typography sx={{ fontSize: "0.85rem", color: "#6b7280" }}>
        {message}
      </Typography>
      {lastUpdated && (
        <Typography sx={{ fontSize: "0.75rem", color: "#9ca3af" }}>
          Last updated {moment(lastUpdated).fromNow()}
        </Typography>
      )}
      {onRetry && (
        <PrimaryButton
          size="sm"
          variant="outlined"
          bgColor="#111827"
          onClick={onRetry}
        >
          <RefreshIcon sx={{ fontSize: 16, mr: 0.75 }} />
          Retry
        </PrimaryButton>
      )}
    </Box>
  );
};

export default ErrorRetry;
